import { Component, Input } from '@angular/core'

@Component({
    selector: 'ppw-multi-client-warning',
    templateUrl: './multi-client-warning.component.html',
    styleUrls: ['./multi-client-warning.component.scss']
})
export class MultiClientWarningComponent {
    @Input() isShown!: boolean
    @Input() message!: string
}
